import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Logs from "./pages/Logs";
import UserLog from "./pages/UserLog";
import PublicDemoPage from "./app_v2/app/PublicDemoPage";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/:company_id",
    element: <App />,
  },
  {
    path: "/v2/:group_id",
    element: <PublicDemoPage />,
  },
  {
    path: "/logs",
    element: <Logs />,
  },
  {
    path: "/logs/:phone",
    element: <UserLog />,
  },
]);

export default routes;
